export default __webpack_public_path__ + "static/media/quiz-pic-1.92d2a6e3.jpeg";